export default __webpack_public_path__ + "2ad0a069c580620af9bfc2bbd13870c6.png";